package com.crowpay.extensions

import com.crowpay.views.theming.body
import com.lightningkite.kiteui.models.DangerSemantic
import com.lightningkite.kiteui.reactive.Readable
import com.lightningkite.kiteui.views.ViewModifiable
import com.lightningkite.kiteui.views.ViewWriter
import com.lightningkite.kiteui.views.l2.RecyclerViewRenderer
import com.lightningkite.kiteui.views.l2.RecyclerViewRendererSet

fun <T, ID, V : T> RecyclerViewRendererSet<T, ID>.renderer(
    render: ViewWriter.(item: Readable<V>, index: Readable<Int>) -> ViewModifiable
) = object : RecyclerViewRenderer<T> {
    override fun render(viewWriter: ViewWriter, data: Readable<T>, index: Readable<Int>): ViewModifiable {
        return try {
            data as Readable<V>
            viewWriter.render(data, index)
        } catch (_: ClassCastException) {
            with (viewWriter) {
                DangerSemantic.onNext - body("Error: Could not resolve item type.")
            }
        }
    }
}